import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
	fetchPendingLevelDetailsThunk,
	fetchPendingTeamMembersThunk,
	fetchProductTeamsThunk,
	fetchSponseredTeamsThunk,
	addTeamMemberThunk,
} from './teamsApis'

const initialState = {
	sponsoredTeamData: [],
	totalCountOfsponsoredTeam: 0,
	myProductTeamData: [],
	myProductTeamDataCount: 0,
	pendingTeamMembersData: [],
	pendingLevelData: [],
}

export const getsponsoredTeamData = createAsyncThunk('user/getsponsoredTeamData', fetchSponseredTeamsThunk)
export const fetchProductTeams = createAsyncThunk('user/fetchProductTeams', fetchProductTeamsThunk)
export const getPendingTeamMembers = createAsyncThunk('user/getPendingTeamMembers', fetchPendingTeamMembersThunk)
export const getPendingLevelDetails = createAsyncThunk('user/getPendingLevelDetails', fetchPendingLevelDetailsThunk)
export const addTeamMember = createAsyncThunk('user/addTeamMember', addTeamMemberThunk)

export const teamsSlice = createSlice({
	name: 'teams',
	initialState,
	reducers: {
		// setUserProfileData: (state, action) => {
		// 	state.profileData = action.payload
		// },
	},
	extraReducers: (builder) => {
		builder.addCase(getsponsoredTeamData.fulfilled, (state, action) => {
			state.sponsoredTeamData = action.payload?.data // Update the state with the profile data
			state.totalCountOfsponsoredTeam = action?.payload?.count // Update the state with the profile data
		})

		builder.addCase(fetchProductTeams.fulfilled, (state, action) => {
			state.myProductTeamData = action.payload?.data // Update the state with the profile data
			state.myProductTeamDataCount = action?.payload?.count // Update the state with the profile data
		})

		builder.addCase(getPendingTeamMembers.fulfilled, (state, action) => {
			state.pendingTeamMembersData = action.payload?.data // Update the state with the profile data
		})
		builder.addCase(getPendingLevelDetails.fulfilled, (state, action) => {
			state.pendingLevelData = action.payload?.data // Update the state with the profile data
		})
	},
})
// export const {} = teamsSlice.actions
export default teamsSlice.reducer
